import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bnCCFormat' })
export class BnCCFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) {
      return '';
    }

    let creditCard = value;
    if (typeof creditCard === 'number') {
      creditCard = value.toString();
    }

    const match = creditCard.match(/.{1,4}/g);

    return match ? match.join(' ') : creditCard;
  }
}
